import { createClient, SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

// Create a mock client that returns empty results when Supabase is not configured
function createMockClient(): SupabaseClient {
  const emptyResponse = { data: [], error: null }
  const mockQuery = () => ({
    select: () => mockQuery(),
    insert: () => mockQuery(),
    update: () => mockQuery(),
    upsert: () => mockQuery(),
    delete: () => mockQuery(),
    eq: () => mockQuery(),
    single: () => Promise.resolve({ data: null, error: null }),
    then: (fn: any) => Promise.resolve(emptyResponse).then(fn),
    ...emptyResponse,
  })
  return {
    from: () => mockQuery(),
    auth: {
      getSession: () => Promise.resolve({ data: { session: null }, error: null }),
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
      signInWithOAuth: () => Promise.resolve({ data: null, error: null }),
      signOut: () => Promise.resolve({ error: null }),
    },
  } as unknown as SupabaseClient
}

export const supabase: SupabaseClient =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          // Persist the session in localStorage so refresh keeps the user logged in
          persistSession: true,
          autoRefreshToken: true,
          // Detect the ?code=... returned by Google OAuth on redirect back to the site
          detectSessionInUrl: true,
          flowType: 'pkce',
        },
      })
    : createMockClient()

export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey)
